import * as React from "react";
import { isEmpty as _isEmpty, isEqual as _isEqual } from "lodash";
import { IConfigPrescriptionMedication } from "../../../models/patients/IConfigBasedPrescription";
import AppUtils from "../../../utils/AppUtils";
import { AppConstants } from "../../../utils/AppConstants";
import { FormItemMode } from "../../../utils/AppConstants";

interface PrescriptionMedicineViewProps {
    data: IConfigPrescriptionMedication;
    index: number
    allData: { item: any, mode: FormItemMode }[];
}

const PrescriptionMedicineView: React.SFC<PrescriptionMedicineViewProps> = (props: PrescriptionMedicineViewProps) => {
    const { data } = props;
    // TODO: change to code after fixing for suggestions
    const isDuplicate = props.allData.findIndex((obj: any) => _isEqual(obj.item.brand, data.brand)) !== props.index
    return (
        <div className={`list-view-template ${isDuplicate ? "is-duplicate" : ""}`}>
            <div className="header-tag">
                <div className="name">{data.brand.displayValue}</div>
                {/*<div className="labTest-instructions">{data.code}</div>*/}
            </div>
            <div className={"meta-container"}>
                {!_isEmpty(data.medicineQuantity) && (data.medicineQuantity.count || data.medicineQuantity.unit) && <div className={"meta-item"}>{`${data.medicineQuantity.count || ""} ${AppUtils.internalToDisplayValue(data.medicineQuantity.unit || "")}`}</div>}
                {data.medicineDosage && <div className={"meta-item"}>{data.medicineDosage}</div>}
                {data.medicineInstructions && <div className={"meta-item"}>{AppConstants.MedicineInstructionCodes[data.medicineInstructions]}</div>}
                {data.frequency && <div className={"meta-item"}>{data.frequency}</div>}
                {data.trouble && data.trouble.displayValue && <div className={"meta-item"}>{data.trouble.displayValue}</div>}
                {!_isEmpty(data.medicineFrequency) && (data.medicineFrequency.count || data.medicineFrequency.unit) && <div className={"meta-item"}>{`${data.medicineFrequency.count || ""} ${AppUtils.internalToDisplayValue(data.medicineFrequency.unit || "")}`}</div>}
                {!_isEmpty(data.medicineDuration) && <div className={"meta-item"}>{`${data.medicineDuration.count || ""} ${data.medicineDuration.unit === "SOS" ? "As & when required" : data.medicineDuration.unit}`}</div>}
                {data.month && <div className={"meta-item"}>{data.month}</div>}
                {data.year && <div className={"meta-item"}>{data.year}</div>}
            </div>
            <div className={"description-container"}>{data.comments || ""}</div>
        </div>
    )
}

export default PrescriptionMedicineView;